export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const SHOW_MSG= 'SHOW_MSG';
export const HIDE_MSG='HIDE_MSG';
export const CLEAR_STATE='CLEAR_STATE';
export const HIDE_MODAL='HIDE_MODAL';
export const SHOW_MODAL='SHOW_MODAL';
export const PICTURE_MODAL='PICTURE_MODAL';
export const WORKFLOW_MODAL='WORKFLOW_MODAL';
export const CONFIRM_MODAL='CONFIRM_MODAL';
export const UPDATE_DATA= 'UPDATE_DATA'
export const ADD_DOCUMENT= 'ADD_DOCUMENT'
export const RESET_DATA= 'RESET_DATA'
export const RESET_DOCUMENT= 'RESET_DOCUMENT'
export const GET_CUSTOMIZATION = 'GET_CUSTOMIZATION';